module.exports = __webpack_public_path__ + "img/Group 2.facd33f4.png";